import { render, staticRenderFns } from "./btn-info.vue?vue&type=template&id=06c7f520&scoped=true"
import script from "./btn-info.vue?vue&type=script&lang=js"
export * from "./btn-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c7f520",
  null
  
)

export default component.exports